import { useMemo } from "react";

import { useLocalStorage } from "usehooks-ts";

import { createFNVHashSync } from "../../../../components/authentication/utils";

import type { SortBy } from "./types";

export type ExternalAccountsState = {
  sortedBy: SortBy;
  hiddenHashedAccountIds: string[];
};

export const DEFAULT_EXTERNAL_ACCOUNTS_STATE: ExternalAccountsState = {
  sortedBy: "alphabetically",
  hiddenHashedAccountIds: [],
};

export const getExternalAccountsStorageKey = (userId: string): string => {
  const hashedId = createFNVHashSync(userId);
  return `external_accounts_${hashedId}`;
};

export const useExternalAccountsStorage = (userId: string) => {
  const storageKey = useMemo(
    () => getExternalAccountsStorageKey(userId),
    [userId]
  );

  const [state, setState, removeValue] = useLocalStorage<ExternalAccountsState>(
    storageKey,
    DEFAULT_EXTERNAL_ACCOUNTS_STATE
  );

  return [state, setState, removeValue] as const;
};
